module.exports = __webpack_public_path__ + "img/xiaoxi.6b7fc6ef.svg";